import ActionsMenu from "../../../../components/action-buttons/ActionsMenu";
import {SurgeryRequestItem} from "../../../../types/surgeryRequests";
import dayjs from "dayjs";
import {getOperationStaffNames} from "../../../../helpers/getOperationStaffNames";
import useOperationStaffController from "../../../../controllers/operationStaff-controller";
import {renderOperationStaffNames} from "../../../../helpers/renderOperationStaffNames";
import {SurgeryRequestsTableServiceProps} from "./types";
import {useAuth} from "../../../../context/authContext";
import {ColumnsType} from "antd/es/table";
import {CalendarOutlined, ClockCircleOutlined} from "@ant-design/icons";
import {canEditSurgeryRequest} from "../../../../helpers/canEditSurgeryRequest";


const useSurgeryRequestsTableService = (props: SurgeryRequestsTableServiceProps) => {
  const {detailsButtonHandler, editButtonHandler, confirmDeleteSurgeryRequest} = props
  const {operationStaffList} = useOperationStaffController()
  const {currentUser} = useAuth();

  const getColumns = (): ColumnsType<SurgeryRequestItem> => [
    {
      title: "Автор",
      dataIndex: 'author',
      align: 'center',
      fixed: 'left',
      render: (_: any, record: SurgeryRequestItem) => record?.author
    },
    {
      title: "Дата та час операції",
      dataIndex: 'operationTime',
      align: 'center',
      fixed: 'left',
      render: (_: any, record: SurgeryRequestItem) => {
        const operationDate = dayjs(record.operationTime)
        return <time className="surgery-request-datetime" dateTime={record.operationTime}>
          <span className="surgery-request-datetime__weekday">{operationDate.locale('uk').format('dddd')}</span>
          <strong className="surgery-request-datetime__date">
            <CalendarOutlined/>{operationDate.format('DD.MM.YYYY')}
          </strong>
          <span className="surgery-request-datetime__time">
            <ClockCircleOutlined/>{operationDate.format('HH:mm')}
          </span>
        </time>
      }
    },
    {
      title: "Операційна",
      dataIndex: 'position',
      align: 'center',
      fixed: 'left',
      render: (_: any, record: SurgeryRequestItem) => record.operationRoom?.name
    },
    {
      title: "ПІБ Пацієнта",
      dataIndex: 'patientName',
      align: 'center',
      render: (_: any, record: SurgeryRequestItem) => record.patientName
    },
    {
      title: "Хірург",
      dataIndex: 'surgeon',
      align: 'center',
      render: (_: any, record: SurgeryRequestItem) => {
        const names = getOperationStaffNames({ids: record.surgeon, staffList: operationStaffList})
        return renderOperationStaffNames(names)
      }
    },
    // {
    //   title: "Асистенти",
    //   dataIndex: 'assistant',
    //   align: 'center',
    //   render: (_: any, record: SurgeryRequestItem) => {
    //     const names = getOperationStaffNames({ids: record.assistant, staffList: operationStaffList})
    //     return renderOperationStaffNames(names)
    //   }
    // },
    // {
    //   title: "Анестезіолог",
    //   dataIndex: 'anesthesiologist',
    //   align: 'center',
    //   render: (_: any, record: SurgeryRequestItem) => {
    //     const names = getOperationStaffNames({ids: record.anesthesiologist, staffList: operationStaffList})
    //     return renderOperationStaffNames(names)
    //   }
    // },
    // {
    //   title: "Сестра анастезистка",
    //   dataIndex: 'anesthesiaNurse',
    //   align: 'center',
    //   render: (_: any, record: SurgeryRequestItem) => {
    //     const names = getOperationStaffNames({ids: record.anesthesiaNurse, staffList: operationStaffList})
    //     return renderOperationStaffNames(names)
    //   }
    // },
    // {
    //   title: "Операційна сестра/брат",
    //   dataIndex: 'scrubNurse',
    //   align: 'center',
    //   render: (_: any, record: SurgeryRequestItem) => {
    //     const names = getOperationStaffNames({ids: record.scrubNurse, staffList: operationStaffList})
    //     return renderOperationStaffNames(names)
    //   }
    // },
    {
      title: "",
      dataIndex: "actions",
      width: 64,
      align: 'center',
      fixed: 'right',
      render: (_: any, record: SurgeryRequestItem) => {
        const isCurrentUserAuthor = currentUser?.id === record.createdById
        return <ActionsMenu
          onDetails={() => detailsButtonHandler(record)}
          onEdit={canEditSurgeryRequest(record, currentUser?.id) ? () => editButtonHandler(record) : undefined}
          onDelete={isCurrentUserAuthor ? () => confirmDeleteSurgeryRequest(record.$id as string) : undefined}
        />
      }
    }
  ]
  return {columns: getColumns()}
}
export default useSurgeryRequestsTableService
